export default __webpack_public_path__ + "static/media/Yun's Crow-Beaked Kisses.22ea8268.jpg";